/* Exemple de classe */
class Carousel {
	constructor() {
		this.dom = {
			C: $(".js-carousel"),
			slides: $(".carousel__inner"),
			current: $(".carousel-progress__current"),
			end: $(".carousel-progress__end"),
			bar: $(".carousel-progress__bar__inner")
		};

		if (!this.dom.C) return;

		this.init();
	}

	init() {
		this.dom.end.text(`0${this.dom.slides.length}`);

		this.dom.C.on("ready.flickity", e => {
			this.dom.bar.addClass("is-animating");
		});

		this.dom.C.flickity({
			pageDots: false,
			setGallerySize: false,
			fade: true,
			draggable: false,
			wrapAround: true,
			autoPlay: 5000,
			pauseAutoPlayOnHover: false
		});

		this.dom.C.on("change.flickity", (event, index) => {
			// this.dom.slides.classList.removeClass("is-active");
			// this.dom.slides[index].addClass("is-active");
			this.dom.bar.removeClass("is-animating");
			setTimeout(() => {
				this.dom.bar.addClass("is-animating");
			}, 100);

			this.dom.current.text(`0${index + 1}`);
		});
	}
}
